export type ControlType = 'text' | 'password' | 'number' | 'select' | 'autocomplete' | 'checkbox';

export interface Control {
  label: string;
  placeholder?: string;
  type: ControlType;
  options?: { label: string; value: string }[];
  controlName: string;
  errors: Record<string, string>;
}

export enum FormType {
  SITE,
  MAIN_SITE,
  SUBDOMAIN,
  ALIAS,
}

export interface WebsiteFormValue {
  type: string;
  websiteId: string;
  originServer: string;
  groupId: string;
  domain: string;
  subdomainMain: string;
  userId: string;
  plan: string;
  enableEmail: boolean;
  installWordpress: boolean;
}

export interface WPFormValue {
  domain: string;
  user: string;
  password: string;
  email: string;
  // directory: string;
  enableRedisCache: boolean;
  enableW3TotalCache: boolean;
  enableWooCommerce: boolean;
  plugins: never;
}
